<template>
  <div class="violation-list-container">
    <div class="violation-list-content">
      <div class="violation-header">
        <div class="header-title">
          <span class="title-icon">⚠️</span>
          <span class="title-text">违规通知列表</span>
        </div>
        <div class="header-desc">以下为考试违规记录，成绩作废处理</div>
      </div>

      <div v-loading="loading" class="violation-table-wrapper">
        <el-table 
          :data="violationList" 
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa', color: '#606266', fontWeight: '600' }"
          :cell-style="{ padding: '16px 0' }"
        >
          <el-table-column type="index" label="序号" width="80" align="center" />
          <el-table-column prop="studentName" label="考生姓名" min-width="120" align="center" />
          <el-table-column prop="idCardMasked" label="身份证号（脱敏）" min-width="180" align="center" />
          <el-table-column prop="examName" label="考试名称" min-width="200" align="center" />
          <el-table-column prop="createTime" label="违规时间" min-width="180" align="center" />
          <el-table-column label="状态" width="100" align="center">
            <template>
              <el-tag type="danger" size="small">违规</el-tag>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="violationList.length === 0 && !loading" class="no-data">
          <el-empty description="暂无违规记录" />
        </div>
      </div>

      <div v-if="total > pageSize" class="pagination">
        <el-pagination
          :current-page="pageNum"
          :page-size="pageSize"
          :total="total"
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getViolationList } from '@/api/certificationApi'

export default {
  name: 'ViolationList',
  data() {
    return {
      loading: false,
      violationList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  mounted() {
    this.fetchViolationList()
  },
  methods: {
    async fetchViolationList() {
      this.loading = true
      try {
        const res = await getViolationList({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        if (res.code === 200) {
          const data = res.data || {}
          this.violationList = Array.isArray(data) ? data : (data.list || data.records || [])
          this.total = data.total || this.violationList.length
        } else {
          this.$message.error(res.message || '获取违规记录失败')
        }
      } catch (err) {
        console.error('获取违规通知列表失败', err)
        this.$message.error(err.message || '获取违规记录失败')
      } finally {
        this.loading = false
      }
    },
    handleCurrentChange(page) {
      this.pageNum = page
      this.fetchViolationList()
    }
  }
}
</script>

<style scoped lang="scss">
.violation-list-container {
  min-height: calc(100vh - 200px);
  background: #f5f7fa;
  padding: 40px 0;
}

.violation-list-content {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 30px;
}

.violation-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.header-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.title-icon {
  font-size: 24px;
}

.title-text {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.header-desc {
  font-size: 14px;
  color: #909399;
  margin-left: 34px;
}

.violation-table-wrapper {
  min-height: 300px;
}

.no-data {
  padding: 60px 0;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

::v-deep .el-table {
  border-radius: 8px;
  overflow: hidden;
}

::v-deep .el-table th {
  background: #f5f7fa !important;
}

::v-deep .el-table__row:hover > td {
  background-color: #f5f7fa !important;
}
</style>
